import { useEffect } from 'react'
import {
  AnalyticsManager,
  EventActions,
  EventCategories,
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '../analytics-manager'
import { zendeskMessengerScriptProps } from '@cinch-labs/shared-zendesk-messenger'
import { datadogRum } from '@datadog/browser-rum'

interface AnalyticsWithZendeskProps {
  enableLiveChat?: boolean
  pathsWithCustomAdobePageViewEventImplementations?: string[]
}

export const AnalyticsWithZendesk = ({
  enableLiveChat = true,
  pathsWithCustomAdobePageViewEventImplementations,
}: AnalyticsWithZendeskProps) => {
  const { trackEvent } = useAnalytics()

  useEffect(() => {
    const handler = () => {
      const pageContext = {
        path: window.location.pathname,
        search: window.location.search,
        referrer: document.referrer,
      }

      const sessionId = datadogRum?.getInternalContext?.()?.session_id

      if (sessionId && window.zE) {
        const stageName = process.env.STAGE_NAME ?? 'local'

        if (stageName === 'production') {
          window.zE('messenger:set', 'conversationFields', [
            { id: '35751819791261', value: sessionId },
            { id: '35751811722397', value: pageContext.path },
          ])
        } else {
          window.zE('messenger:set', 'conversationFields', [
            { id: '35538105112733', value: sessionId },
            { id: '35538060820509', value: pageContext.path },
          ])
        }
      }

      trackEvent({
        type: TrackingEventTypes.ADOBE,
        eventName: 'Zendesk chatbot - button clicked',
        data: {
          event: {
            action: EventActions.modalOpened,
            name: EventNames.click,
            category: EventCategories.zendeskChatbot,
            label: 'zendesk-chatbot',
            type: 'support',
          },
        },
      })
    }

    window.addEventListener('zendesk:open', handler)
    return () => window.removeEventListener('zendesk:open', handler)
  }, [trackEvent])

  return (
    <AnalyticsManager
      enableLiveChat={enableLiveChat}
      pathsWithCustomAdobePageViewEventImplementations={
        pathsWithCustomAdobePageViewEventImplementations
      }
      zendeskChatBotScript={
        <script
          {...zendeskMessengerScriptProps({
            id: 'ze-snippet',
            env: process.env['STAGE_NAME'] || 'development',
          })}
        />
      }
    />
  )
}
